import {get_paiement} from 'backend/immoModule.jsw'
import {get_capital} from 'backend/immoModule.jsw'
import {get_periods} from 'backend/immoModule.jsw'
import {stringToNumber} from 'public/common.js'
import {currencyFormat} from 'public/common.js'
import {allnumeric} from 'public/common.js'

let CA, IN, PE, MP, CA_old, MP_old, IN_old, IN_curr, PE_old, PE_curr

$w.onReady(function () {
	
	CA = 500000
	IN = '1.80'
	PE = 15
	MP = 3172

	// Inital filling for Monthly Paiements
	$w('#inputAmount').value = currencyFormat(CA) 
	$w('#inputRate').value = IN
	$w('#inputYears').value = PE.toString()

	$w("#textPmnts").text = currencyFormat(MP)
	$w("#textCapital").text = currencyFormat(CA)
	$w("#textRate").text = IN.toString()

	// Initial filling for Capital Amount
	$w('#inputRte').value = IN.toString()
	$w('#inputMthlyAmnt').value = currencyFormat(MP)
	$w('#inputYearCap').value = PE.toString()

	
	$w("#textMthlyPmnt").text = currencyFormat(MP)
	$w("#textCap").text = currencyFormat(CA)
	$w("#textRte").text = IN.toString()
	
});

/*
*   The block hereunder is the algorithm for computing MONTHLY PAIEMENTS
*/

export async function buttonCalc_click(event) {
	
	CA = stringToNumber($w('#inputAmount').value)
	IN = Number($w('#inputRate').value)
	PE = Number($w('#inputYears').value)

	if ((IN > 0 && IN < 16) && (PE >= 1 && PE < 31)) {

		MP = await get_paiement(CA, IN, PE)
	
		if (MP > 0) {

			$w("#textPmnts").text = currencyFormat(MP)
			$w("#textCapital").text = $w('#inputAmount').value
			$w("#textRate").text = $w('#inputRate').value

		}
		
	}

}

export async function inputAmount_click(event) {
	
	CA = await stringToNumber($w('#inputAmount').value)

	$w('#inputAmount').value = CA

	CA_old = CA

}

export async function inputAmount_mouseOut(event) {
	
		CA = await stringToNumber($w('#inputAmount').value)
		
		if (allnumeric(CA) === 1) {

			$w('#inputAmount').value = await currencyFormat(Number(CA))

		}
		else {

			$w('#inputAmount').value = await currencyFormat(Number(CA_old))	

		}

		$w('#inputAmount').blur()

}

export function inputRate_click(event) {

	IN_old = $w('#inputRate').value

}

export async function inputRate_mouseOut(event) {

	IN_curr = $w('#inputRate').value

	IN = await stringToNumber($w('#inputRate').value)
		
	if (allnumeric(IN) === 1) {

		$w('#inputRate').value = IN_curr

	}
	else {

		$w('#inputRate').value = IN_old

	}

	$w('#inputRate').blur()

}

export function inputYears_click(event) {

	PE_old = $w('#inputYears').value

}

export function inputYears_mouseOut(event) {
	
	PE = $w('#inputYears').value
		
	if (allnumeric(PE) === 1) {

		$w('#inputYears').value = PE

	}
	else {

		$w('#inputYears').value = PE_old

	}

	$w('#inputYears').blur()

}


/*
*   The block hereunder is the algorithm for computing MAXIMUM AMOUNT availalble
*/


export async function buttonCalCap_click(event) {

	IN = Number($w('#inputRte').value)
	MP = stringToNumber($w('#inputMthlyAmnt').value)
	PE = Number($w('#inputYearCap').value)

	if ((IN > 0 && IN < 16) && (PE >= 1 && PE < 31)) {

		CA = await get_capital(MP, IN, PE)    // calcul emprunt maxi

		if (CA > 0) {

			console.log(CA)
		
			$w("#textMthlyPmnt").text = $w('#inputMthlyAmnt').value
			$w("#textCap").text = currencyFormat(CA)
			$w("#textRte").text = $w('#inputRte').value

		}
	}
}

export async function inputMthlyAmnt_click(event) {

	MP = stringToNumber($w('#inputMthlyAmnt').value)

	$w('#inputMthlyAmnt').value = MP

	MP_old = MP

}

export async function inputMthlyAmnt_mouseOut(event) {
	
	MP = await stringToNumber($w('#inputMthlyAmnt').value)
		
	if (allnumeric(MP) === 1) {

		$w('#inputMthlyAmnt').value = await currencyFormat(Number(MP))

	}
	else {

		$w('#inputMthlyAmnt').value = await currencyFormat(Number(MP_old))	

	}

	$w('#inputMthlyAmnt').blur()

}

export function inputRte_click(event) {
	
	IN_old = $w('#inputRte').value

}

export async function inputRte_mouseOut(event) {
	
	IN_curr = $w('#inputRte').value

	IN = await stringToNumber($w('#inputRte').value)
		
	if (allnumeric(IN) === 1) {

		$w('#inputRte').value = IN_curr

	}
	else {

		$w('#inputRte').value = IN_old

	}

	$w('#inputRte').blur()

}

export function inputYearCap_click(event) {
	
	PE_old = $w('#inputYearCap').value

}

export function inputYearCap_mouseOut(event) {
	
	PE = $w('#inputYearCap').value
		
	if (allnumeric(PE) === 1) {

		$w('#inputYearCap').value = PE

	}
	else {

		$w('#inputYearCap').value = PE_old

	}

	$w('#inputYearCap').blur()

}